import React, { Fragment, useState } from "react";
import SelectMap from "./SelectMap";
import { INIT_INPUTS, PASSENGER_INFO } from "./data";
import Translate from "Components/Translate";
import PassengerForm from "./PassengerForm";
import { TAXI } from "Constant";
import { Dropdown } from "primereact/dropdown";
import useFetchData from "hooks/useFetchData";
import { getCodeLabel } from "helper/getOptions";
import { getData } from "helper/getData";
import SendBtn from "./SendBtn";

const CreateBooking = ({ INPUT = INIT_INPUTS, closeModal }) => {
  const [inputs, setInputs] = useState(INPUT);
  const [passengerInfo, setPassengerInfo] = useState({});
  const [formMethods, setFormMethods] = useState(null);
  const [mapMethods, setMapMethods] = useState(null);
  const { data, isLoading } = useFetchData("/front/taxisChoices");

  // Process the options data
  const options = data ? getCodeLabel(getData(data)) : [];

  const handleFormSubmit = async (data) => {
    let isValid = true;

    // Validate passenger form
    if (formMethods) {
      isValid = await formMethods.trigger();
      if (!isValid) {
        // Show all field errors
        Object.keys(formMethods.getValues()).forEach((key) => {
          formMethods.trigger(key);
        });
      }
    }

    // Validate map locations
    if (mapMethods && isValid) {
      isValid = mapMethods.validateLocations();
    }

    return isValid;
  };

  const onChangeTaxi = (val) => {
    setInputs((prevState) => ({ ...prevState, taxi: val }));
  };

  console.log(inputs);
  console.log(passengerInfo);

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <PassengerForm
        passengerInfo={passengerInfo}
        setPassengerInfo={setPassengerInfo}
        inputs={inputs}
        setInputs={setInputs}
        onValidSubmit={setFormMethods}
        options={options}
        isLoading={isLoading}
        onChangeTaxi={onChangeTaxi}
      />
      
      <SelectMap 
        inputs={inputs} 
        setInputs={setInputs}
        onValidSubmit={setMapMethods}
      />

      <SendBtn 
        inputs={inputs} 
        passengerInfo={passengerInfo} 
        onBeforeSubmit={handleFormSubmit}
        closeModal={closeModal}
      />
    </form>
  );
};

export default CreateBooking;
